import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectEditScope = () => createSelector(substate, (contextState) => contextState.editScope);
